import { Routes } from '@angular/router';
export const routes: Routes = [
    { path: '', pathMatch: 'full', redirectTo: 'auth/login' },  // Default route
    {
        path: 'auth',
        loadChildren: () => import('./pages/auth/auth.module').then(m => m.AuthModule),
    },
    {
        path: 'admin',
        loadChildren: () => import('./pages/admin/admin.module').then(m => m.AdminModule)
    },
    { path: '**', redirectTo: 'auth/login', pathMatch: 'full' }  // Handle unknown routes
];
